import React from 'react';
import { formatCurrencyCompact, formatStat } from '../../utils/formatters';

function DeltaCell({ value }) {
  if (value == null || isNaN(value) || value === 0) return <span className="text-gray-400 text-[10px]">-</span>;
  const isPositive = value > 0;
  return (
    <span className={isPositive ? 'metric-badge-up' : 'metric-badge-down'}>
      {isPositive ? '+' : ''}{Number(value).toFixed(1)}%
    </span>
  );
}

export function WeekOverWeekSummary({ weeklyWoWSummary }) {
  if (!weeklyWoWSummary?.length) {
    return <p className="text-xs text-gray-400 text-center py-4">No week-over-week data available</p>;
  }

  return (
    <div className="overflow-x-auto">
      <table className="modern-table">
        <thead>
          <tr>
            <th className="text-left">Week</th>
            <th className="text-right">Revenue</th>
            <th className="text-center">Chg</th>
            <th className="text-right">Sessions</th>
            <th className="text-center">Chg</th>
            <th className="text-right">Trans.</th>
            <th className="text-center">Chg</th>
            <th className="text-right">CR%</th>
            <th className="text-center">Chg</th>
          </tr>
        </thead>
        <tbody>
          {weeklyWoWSummary.map((week, i) => (
            <tr key={i}>
              <td className="text-xs font-medium text-gray-700">{week.weekKey}</td>
              <td className="text-right text-xs font-medium">{formatCurrencyCompact(week.revenue)}</td>
              <td className="text-center"><DeltaCell value={week.deltas?.rev} /></td>
              <td className="text-right text-xs">{formatStat(week.sessions)}</td>
              <td className="text-center"><DeltaCell value={week.deltas?.sess} /></td>
              <td className="text-right text-xs">{formatStat(week.transactions)}</td>
              <td className="text-center"><DeltaCell value={week.deltas?.trans} /></td>
              <td className="text-right text-xs">{(week.cr || 0).toFixed(2)}%</td>
              <td className="text-center"><DeltaCell value={week.deltas?.cr} /></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
